import FIKA from "assets/images/icons/fika-icon.svg";
import TRENT from "assets/images/icons/trent-icon.svg";
import GENERICO from "assets/images/icons/generico-icon.svg";
import SINASIGNAR from "assets/images/icons/sinAsignar-icon.svg";
import FEMMTO from "assets/images/icons/femmto-icon.svg";
import MeliIcon from "assets/images/icons/meli-icon.svg";
import VtexIcon from "assets/images/icons/vtex-icon.svg";
import AmazonIcon from "assets/images/icons/amazon-icon.svg";
import B2bIcon from "assets/images/icons/b2b-icon.svg";
import styled from "@emotion/styled";
import { Switch } from "@mui/material";

export const COLUMNS_TO_FILTER = [
  { data: "thumbnail", label: "Foto" },
  { data: "sku", label: "SKU" },
  { data: "status", label: "Estado" },
  {
    data: "itemid",
    label: "Marketplace ID",
  },
  {
    data: "seller",
    label: "Seller",
  },
  {
    data: "listingtypename",
    label: "Tipo de publicación",
  },
  {
    data: "ratingaverage",
    label: "Reviews",
  },
  { data: "ranking", label: "Ranking" },
  {
    data: "logistictype",
    label: "Tipo de envío",
  },

  {
    data: "ux",
    label: "Ux",
  },
  { data: "soldquantity", label: "Ventas" },
  { data: "freeshipping", label: "Free Shipping" },
];

export const REVIEWS_TO_FILTER = [
  { id: 1, label: "1" },
  { id: 2, label: "2" },
  { id: 3, label: "3" },
  { id: 4, label: "4" },
  { id: 5, label: "5" },
  { id: 6, label: "0" },
];

export const INITIAL_COLUMNS_STATE = {
  thumbnail: true,
  sku: true,
  status: true,
  itemid: true,
  seller: true,
  listingtypename: true,
  ratingaverage: true,
  ranking: true,
  logistictype: true,
  ux: true,
  soldquantity: true,
  freeshipping: true,
};
export const INITIAL_UX_STATE = ["100-75", "74-31", "30-0", "-1"];
export const INITIAL_REVIEWS_STATE = ["1", "2", "3", "4", "5", "0"];

export const UX_TO_FILTER = [
  { id: 1, label: "100-75", color: "#61B477" },
  { id: 2, label: "74-31", color: "#FF7A39" },
  { id: 3, label: "30-0", color: "#D32F2F" },
  { id: 4, label: "-1" },
  //   { id: 5, label: "0", description: "(sin datos)" },
];

export const INITIAL_LISTINGTYPENAMES_STATE = [
  { id: 0, data: "Todas", label: "Todas" },
  { id: 1, data: "Clásica", label: "Clásica" },
  { id: 2, data: "Premium", label: "Premium" },
];

export const brandIcons = {
  FIKA: FIKA,
  TRENT: TRENT,
  GENERICO: GENERICO,
  "SIN ASIGNAR": SINASIGNAR,
  FEMMTO: FEMMTO,
};

export const MarketplaceIcons = {
  MELI: MeliIcon,
  VTEX: VtexIcon,
  AMZN: AmazonIcon,
  OFF: B2bIcon,
};

export const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    "&.Mui-checked": {
      color: "#354887", // color del switch cuando está encendido
      "& + .MuiSwitch-track": {
        backgroundColor: "#9aa3c3", // color del cuerpo cuando está encendido
      },
    },
  },
}));
